import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStakeholderGroupsRoute: InvariantJiraRoute = {
	name: 'communications-stakeholder-groups',
	path: '/jira/communications/stakeholder-groups',
};
